import { navigateTo } from '@max/meituan-uni-navigate';
import { KNB } from '@nibfe/mkt-common-utils';
export const yuanToFen = (yuan) => {
    const _yuan = Number(yuan);
    if (isNaN(_yuan))
        return '';
    const fen = Math.round(_yuan * 100);
    return fen.toString();
};
// 从cid解析通道
export const getChannelName = (cid) => {
    var _a;
    if (!cid)
        return 'daodian_lowcode';
    return ((_a = (cid || '').match(/c_(.*)_(\w*)/)) === null || _a === void 0 ? void 0 : _a[1]) || 'daodain_lowcode';
};
export const navigateToPage = (link, verifyFailCb, navigateFailCb) => {
    if (!link)
        return;
    navigateTo({
        url: link,
        _web: {
            miniProgramNative: true
        },
        _meituan: {
            enableElinkLog: true
        },
        verifyFail: validate => {
            verifyFailCb && verifyFailCb(JSON.stringify(validate || {}));
        }
    }).then(res => { }).catch(err => {
        const reporError = {
            err,
            url: link
        };
        navigateFailCb && navigateFailCb(JSON.stringify(reporError));
    });
};
export function throttle(func, delay) {
    let timer = null;
    let lastExecTime = 0;
    return function (...args) {
        const currentTime = Date.now();
        const remainingTime = delay - (currentTime - lastExecTime);
        if (remainingTime <= 0) {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            lastExecTime = currentTime;
            func();
        }
    };
}
// KNB获取定位城市，当没有权限时，会返回缓存的定位城市，所以这里处理一下，当没有权限返回'0'
export function getCityInfo() {
    return new Promise(resolve => {
        KNB.getCity({
            success: function (city) {
                const { cityId, locCityId } = city || {};
                KNB.requestPermission({
                    type: 'location',
                    readonly: true,
                    forceJump: false,
                    success: function (res) {
                        resolve({
                            cityId,
                            locCityId
                        });
                    },
                    fail: function (res) {
                        resolve({
                            cityId,
                            locCityId: '0'
                        });
                    }
                });
            },
            fail: function (city) {
                resolve({
                    cityId: '0',
                    locCityId: '0'
                });
            }
        });
    });
}
